import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate("/dashboard"), 5000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 bg-gradient-to-br from-forfy-50 via-white to-neutral-50">
      <div className="w-full max-w-md rounded-2xl shadow-xl border border-neutral-100 bg-white p-8 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-emerald-100 mb-4">
          <CheckCircle2 className="w-7 h-7 text-emerald-600" />
        </div>
        <h1 className="text-2xl font-display font-semibold text-neutral-900">Benvenuto in Forfy Pro! 🎉</h1>
        <p className="mt-2 text-sm text-neutral-500">
          Il pagamento è andato a buon fine. L'attivazione del piano può richiedere qualche secondo.
          Ti riportiamo alla dashboard…
        </p>
        <Link to="/dashboard" className="inline-flex items-center gap-1.5 mt-6 text-sm font-medium text-forfy-700 hover:text-forfy-800">
          Vai alla dashboard ora
        </Link>
      </div>
    </div>
  );
}
